<template>
	<div class="custom-chart-legends">
		<a
			href="#"
			@click.prevent="toggleDataset(index)"
			class="legend"
			v-for="(dataset, index) in datasets"
			:class="{disabled: dataset.hidden}">
			<span v-if="actions < 0"></span><span class="legend-color" :style="legendStyle(dataset)"></span><span class="legend-label">{{ __(dataset.label) }}</span>
		</a>
	</div>
</template>

<script>
export default {
	props: ['datasets'],
	data() {
		return {
			actions: 0
		}
	},
	methods: {
		legendStyle(dataset) {
			return {
				backgroundColor: dataset.borderColor
			}
		},
		toggleDataset(index) {

			// stupid hack to trigger re-render
			this.actions++

			this.$parent.toggleDataset(index)
		}
	}
};
</script>